export class PassKinds {
    static TRANSPORT = 'transport'
    static PEDESTRIAN = 'pedestrian'
    static MATERIAL = 'material'
    static UNIVERSAL = 'universal'
    static PHD = 'phd'
}
